import React, { useRef } from 'react';
import SignatureCanvas from 'react-signature-canvas';

/**
 * Signature Component using react-signature-canvas
 * Allows users to draw digital signatures
 */
const SignatureComponent = ({ onSave }) => {
  const sigCanvas = useRef(null);

  const clear = () => {
    if (sigCanvas.current) {
      sigCanvas.current.clear();
    }
  };

  const save = () => {
    if (sigCanvas.current) {
      const dataURL = sigCanvas.current.toDataURL();
      if (onSave) {
        onSave(dataURL);
      }
      console.log('Signature saved:', dataURL);
    }
  };

  return (
    <div className="signature-component">
      <div className="signature-pad-container">
        <SignatureCanvas
          ref={sigCanvas}
          canvasProps={{
            className: 'signature-canvas',
          }}
          backgroundColor="white"
        />
      </div>
      <div className="signature-actions mt-3">
        <button className="btn btn-secondary me-2" onClick={clear}>
          Clear
        </button>
        <button className="btn btn-primary" onClick={save}>
          Save Signature
        </button>
      </div>
    </div>
  );
};

export default SignatureComponent;
